module.exports = __webpack_public_path__ + "static/media/thrive_logo.3adc97b1.svg";